import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { EntityKeyResponse } from '@feature/pma-entity/pma-entity-types';

@Injectable({
  providedIn: 'root'
})
export class PmaEntityKeyHttpService {

  constructor(
    private readonly urlBuilder: UrlBuilderService,
    private readonly http: HttpClient) { }


  getKey(routeParams: object): Observable<EntityKeyResponse> {
    const url = this.urlBuilder.getUrl(`entity-key`);
    return this.http.post<EntityKeyResponse>(url, routeParams);
  }
}
